import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import ParticipanteDash from './modules/participante/dash.jsx';
import AprobarSolicitudes from './modules/empleados/solicitudesParticipantes';
import MiniDrawer from './components/Nav.jsx';
import SignInSide from './modules/Login/login.jsx';
import VistaParticipanteSolicitudes from './modules/participante/VistaParticipanteSolicitudes.jsx';
import SolicitudCarga from './modules/participante/SolicitudCarga.jsx';
import SessionContextProvider from './services/ContextSession.jsx';
import EmpleadosDash from './modules/empleados/ListaEmpleados.jsx';
import PantallaInicio from './modules/PantallaInicio.jsx';
import AsignarSolicitudes from './modules/empleados/asignar_solicitudes.jsx';
import MisSolicitudes from './modules/ListaParticipante.jsx';
import CrearUsuarios from './modules/empleados/crear_usuarios.jsx';
import CambiarPassword from './modules/Login/cambio_password.jsx';
import QuejasSugerencias from './modules/participante/quejas.jsx';
//import MaintenancePage from './modules/Error.jsx';
import PaginaInicioPortal from './modules/pagina inicio/paginainicio.jsx';
import SeleccionarSolicitud from './modules/participante/seleccionar_solicitud.jsx';
import SolicitudSimplificada from './modules/participante/SolicitudSimplificada.jsx';
import SolicitudCargaSimplificada from './modules/participante/SolicitudCarga_simplificada.jsx';
import VerQuejasSugerencias from './modules/participante/ver_quejas.jsx';
import Direcciones from './modules/direcciones.jsx';
import ContractForm from './modules/participante/firmar_contrato.jsx';
import MisDatos from './modules/participante/mis_datos.jsx';
import MiPerfil from './modules/participante/mi_perfil.jsx';
import Inbox from './modules/participante/buzon.jsx';
import NotFoundPage from './modules/404 Not Found/404.jsx';
import ActualizarCorreo from './modules/pagina inicio/actualizar_correo.jsx';
import ConstanciaJubilacionScreen from './modules/participante/constancias/constancia_jubilacion.jsx';
import ServiciosPortal from './modules/pagina inicio/servicios_disponibles.jsx';
import Cotizaciones from './modules/participante/cotizaciones.jsx';
import RevalorizacionScreen from './modules/participante/revalorizacion.jsx';
import PoliticasFeVida from './modules/pagina inicio/politicas_fevida.jsx';
import ProtectedRoute from "./services/protectedRoute.jsx"; // Importa el componente ProtectedRoute

import ConstanciaRazonadaScreen from './modules/participante/constancias/constancia_razonada.jsx';
import ConstanciaRazonadaScreenSubSanar from './modules/participante/constancias/constancia_razonada_subsanar.jsx';

import ConstanciaHistorialCotizacionesScreen from './modules/participante/constancias/constancia_historialcot.jsx';
import ConstanciaHistorialScreenSubSanar from './modules/participante/constancias/constancia_historialcot_subsanar.jsx';
import ConstanciaPrestacionesScreen from './modules/participante/constancias/constancia_prestaciones.jsx';
import ConstanciaPrestacionesScreenSubSanar from './modules/participante/constancias/constancia_prestaciones_subsanar.jsx';

const router = createBrowserRouter([
  {
    path: '/',
    element: <PaginaInicioPortal /> // Página de inicio sin MiniDrawer
  },
  {
    path: 'Login',
    element: <SignInSide /> // Página de inicio sin MiniDrawer
  },
  {
    path: 'CambioClave',
    element: <CambiarPassword /> // Ruta de cambio de clave sin MiniDrawer
  },
  {
    path: 'Contrato',
    element: <ContractForm />
  },
  {
    path: 'ServiciosDisponibles',
    element: <ServiciosPortal />
  },
  {
    path: 'PoliticasPruebaSobrevivencia',
    element: <PoliticasFeVida />
  },
  {
    path: 'ActualizarCorreo',
    element: <ActualizarCorreo />
  },
  {
    element: (
      <ProtectedRoute>
        <MiniDrawer />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'Mis Solicitudes',
        children: [
          { index: true, element: <ParticipanteDash /> },
          { path: 'FormularioCompleto', element: <VistaParticipanteSolicitudes /> },
          { path: 'Formulario', element: <SolicitudSimplificada /> },
          { path: 'SolicitudesCargaPreAnalisis', element: <SolicitudCargaSimplificada /> },
          { path: 'SolicitudesCarga', element: <SolicitudCarga /> },
          { path: 'MisSolicitudes', element: <MisSolicitudes /> },
          { path: 'QuejasSugerencias', element: <QuejasSugerencias /> },
          { path: 'ConstanciaJubilacion', element: <ConstanciaJubilacionScreen /> },
          { path: 'SeleccionarSolicitud', element: <SeleccionarSolicitud /> },
          { path: 'VerQuejasSugerencias', element: <VerQuejasSugerencias /> },
          { path: 'MisDatos', element: <MisDatos /> },
          { path: 'MiPerfil', element: <MiPerfil /> },
          { path: 'ConstanciaRazonada', element: <ConstanciaRazonadaScreen /> },
          { path: 'SolicitudConstanciaSubsanar', element: <ConstanciaRazonadaScreenSubSanar /> },
          { path: 'ConstanciaHistorialCotizaciones', element: <ConstanciaHistorialCotizacionesScreen /> },
          { path: 'SolicitudConstanciaHistorialSubsanar', element: <ConstanciaHistorialScreenSubSanar /> },
          { path: 'SolicitudConstanciaPrestaciones', element: <ConstanciaPrestacionesScreen /> },
          { path: 'SolicitudConstanciaPrestacionesSubsanar', element: <ConstanciaPrestacionesScreenSubSanar /> },
        ]
      },
      {
        path: 'Mi Información',
        children: [
          { path: 'MisDatos', element: <MisDatos /> },
          { path: 'MiPerfil', element: <MiPerfil /> },
          { path: 'Cotizaciones', element: <Cotizaciones /> },
          { path: 'Revalorizacion', element: <RevalorizacionScreen /> },
        ]
      },
      {
        path: 'Empleados',
        children: [
          { index: true, element: <EmpleadosDash /> },
          { path: 'SolicitudesParticipantes', element: <AprobarSolicitudes /> },
          { path: 'AsignarSolicitudes', element: <AsignarSolicitudes /> },
          { path: 'CrearUsuarios', element: <CrearUsuarios /> }
        ]
      },
      {
        path: 'Dashboard',
        children: [
          { index: true, element: <PantallaInicio /> }
        ]
      },
      {
        path: 'Ubicaciones INJUPEMP',
        children: [
          { index: true, element: <Direcciones /> }
        ]
      },
      {
        path: 'Buzón',
        children: [
          { index: true, element: <Inbox /> }
        ]
      }
    ]
  },
  {
    path: '*',
    element: <NotFoundPage /> // Ruta para páginas no encontradas
  }
]);

function App() {
  return (
    <SessionContextProvider>
      <RouterProvider router={router} />
    </SessionContextProvider>
  );
}

export default App;
